module.exports = "/_next/static/images/ico-abus-2882796e46446190fbf99d8967ddfd85.svg";